<script lang="ts">
  import type { PageContent } from '$lib/def/seo/page';
	import { createLinkEditorAction } from '$lib/serv/admin/editLink';

	export let index: number;
	export let content: PageContent;
	export let editHref: ((current:string) => Promise<string|undefined>) | undefined;
	
	const editUrl = createLinkEditorAction('page', content.slug);
</script>

<!-- svelte-ignore a11y-missing-attribute --><!-- added by action -->
<a class='m-auto' use:editUrl={[`block-${index}-link`, current => editHref?.(current)]}>
	<slot/>
</a>
